module.exports = "/shared/img/slip-arrow-down.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/slip-arrow-down.png
// module id = 451
// module chunks = 13